import React from "react";
export var Calendar = function (_a) {
    var width = _a.width, height = _a.height, fill = _a.fill, title = _a.title;
    return (React.createElement("svg", { width: width, height: height, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, title),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a1 1 0 011 1v1h6V2a1 1 0 112 0v1h2a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3V6a3 3 0 013-3h2V2a1 1 0 011-1zM7 5H5a1 1 0 00-1 1v3h16V6a1 1 0 00-1-1h-2v1a1 1 0 11-2 0V5H9v1a1 1 0 01-2 0V5zm13 6H4v9a1 1 0 001 1h14a1 1 0 001-1v-9z", fill: fill })));
};
